/**
 * Pastille « note d'équipe » d'un match (note pondérée par les minutes, calculée
 * serveur). Réutilisée autour du score dans la fiche match et la carte live.
 * Seuils ABAISSÉS vs la note joueur (≥7,0 vert) : une note collective a une
 * variance plus faible et tourne ~6,5–7,2, donc ≥7,5 rendrait tout ambre.
 */
import { teamRatingOf, teamTrendOf, type Trend } from "../app/teamRatings.ts";
import { t } from "../app/i18n.ts";

export const teamRateCls = (r: number): string => (r >= 7.0 ? "hi" : r >= 6.5 ? "mid" : "lo");

/** Pastille HTML de la note d'équipe d'un match, ou "" si la note est absente. */
export function teamRatingTag(matchId: number, code: string): string {
  const tr = teamRatingOf(matchId, code);
  if (!tr) return "";
  return `<span class="tr-badge ${teamRateCls(tr.rating)}" title="${t("fiche.teamRating.tagTitle", { n: tr.n })}">${tr.rating.toFixed(1)}</span>`;
}

const TREND_ICON: Record<Trend, string> = { up: "ti-trending-up", down: "ti-trending-down", flat: "ti-minus" };
const trendLbl = (): Record<Trend, string> => ({
  up: t("fiche.teamRating.trend.up"),
  down: t("fiche.teamRating.trend.down"),
  flat: t("fiche.teamRating.trend.flat"),
});

/** Flèche SEULE de tendance de forme d'une équipe (sa note d'équipe récente), ou
 *  "" si pas d'historique. Sert la carte d'un match NON terminé (pas encore noté). */
export function teamTrendTag(code: string): string {
  const tr = teamTrendOf(code);
  if (!tr) return "";
  return `<span class="tr-trend ${tr}" title="${trendLbl()[tr]} ${t("fiche.teamRating.trendTitleSuffix")}"><i class="ti ${TREND_ICON[tr]}" aria-hidden="true"></i></span>`;
}
